import { theme } from 'styled-tools';
import styled from './styled.js';
import as from './as.js';
import Flex from './Flex.js';
import 'styled-components';
import './chunk-fb907809.js';
import '@emotion/is-prop-valid';
import 'react';
import 'hoist-non-react-statics';
import 'prop-types';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';
import './Box.js';

var InlineFlex = styled(Flex).withConfig({
  displayName: "InlineFlex",
  componentId: "sc-129poqw-0"
})(["display:inline-flex;", ";"], theme("InlineFlex"));
var InlineFlex$1 = as("div")(InlineFlex);

export default InlineFlex$1;
